module.exports = __webpack_public_path__ + "img/icon_xx2.701c1af.png";